import React, { createContext, useCallback, useContext, useState } from 'react';

interface AnimalFilters {
  estado: string;
  sexo: string;
  ano: string;
  raça: string;
  categoria: string;
  safra: string;
  lote: string;
  pertencentes: string;
}

interface AnimalFiltersData {
  animalFilters: AnimalFilters;
  setAnimalFilters(animalFilters: AnimalFilters): void;
  clearAnimalFilters(): void;
}

export const AnimalFiltersContext = createContext<AnimalFiltersData>(
  {} as AnimalFiltersData,
);

export const AnimalFiltersProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AnimalFilters>({
    estado: 'ativo',
    sexo: '',
    ano: '',
    raça: '',
    categoria: '',
    safra: '',
    lote: '',
    pertencentes: 'true',
  });

  const setAnimalFilters = useCallback(
    (animalFilters: AnimalFilters) => {
      setData(animalFilters);
    },
    [data, setData],
  );

  const clearAnimalFilters = useCallback(() => {
    setData({
      estado: 'ativo',
      sexo: '',
      ano: '',
      raça: '',
      categoria: '',
      safra: '',
      lote: '',
      pertencentes: 'true',
    });
  }, [data, setData]);

  return (
    <AnimalFiltersContext.Provider
      value={{
        animalFilters: data,
        setAnimalFilters,
        clearAnimalFilters,
      }}
    >
      {children}
    </AnimalFiltersContext.Provider>
  );
};

export function useAnimalFilters(): AnimalFiltersData {
  const context = useContext(AnimalFiltersContext);

  if (!context) {
    throw new Error('Context must be used within a ContextProvider');
  }
  return context;
}
